module.exports = __webpack_public_path__ + "static/media/bottle-05.ee48ffeb.png";